import { ImageContent } from '../../models/image.model';
import { ImageDisplay } from './ImageDisplay';

interface Props {
    image: ImageContent;
}

export const ImageContentDisplay = ({ image }: Props): React.ReactElement<any, any> | null => {
    return (
        <ImageDisplay imgClassName="content-section-image" alt={image.alt || ''} src={image.url} />
    );
};
